export default (number, factionDigits = 2) => {
  if (number > 0) {
    if (Number.isNaN(Number(number))) return (0).toFixed(factionDigits);

    const re = new RegExp('(\\d+\\.\\d{' + factionDigits + '})(\\d)'),
      m = number.toString().match(re);
    return m ? parseFloat(m[1]).toFixed(factionDigits) : number.valueOf().toFixed(factionDigits);
  } else return '00.00';
};
